import { SpacerBlockData } from "@/storyblok/schemas";
import { makeEditable } from "@/storyblok/visual-editor";

export default function Spacer({ data }: { data: SpacerBlockData }) {
  return (
    <section className="section--spacer" {...makeEditable(data)}></section>
  );
}
